import * as React from "react";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";

import { Container } from "@material-ui/core";

import { App } from "App";

import { User } from "Utility/User";
import { Status, useHttpGet } from "Utility/useHttp";

import { IQuiltConfig } from "Model/IQuiltConfig";

import { RequestProgress } from "Components/RequestProgress";

function makeUser(user: firebase.User): User {
    const getTokenAsync = async (): Promise<string> => {
        try {
            const token = await user.getIdToken();

            return token;
        } catch {
            return "";
        }
    };

    if (!user.emailVerified) {
        return undefined;
    }

    return {
        id: user.uid,
        email: user.email!,
        getTokenAsync
    };
}

export function AppLoader(): React.ReactElement {
    const configRequest = useHttpGet<IQuiltConfig>("/api/quilt/config");
    const [user, setUser] = React.useState<User | null>(null);

    React.useEffect(() => {
        const unregisterAuthObserver = firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                setUser(makeUser(user));
            } else {
                setUser(undefined);
            }
        });

        return () => unregisterAuthObserver();
    },
    []);

    let combinedRequest = {...configRequest};

    if (user === null) {
        combinedRequest = {
            status: Status.Loading
        };
    }

    if (combinedRequest.status !== Status.Complete) {
        return (
            <Container fixed>
                <RequestProgress request={combinedRequest} errorMessage="Failed to load quilt config." />
            </Container>
        );
    }

    return <App user={user!} config={combinedRequest.data} />;
}
